export default "__VITE_ASSET__N5XS6gue__"